import React from 'react';
import Chart from 'react-apexcharts';
import './RewardBarChart.scss';

interface IRewardBarChart{
  barSeries:any;
  barCategory:any;
}
const RewardBarChart = ({ barSeries, barCategory }:IRewardBarChart) => {
  const datas = {
    options: {
      chart: {
        id: 'basic-bar',

      },
      colors: ['#5941A9'],
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: barCategory || ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      },
      yaxis: {
        // min: 0,
        // max: 600,
        // stepSize: 100,
      },
    },
    series: [
      {
        name: 'Total referrals',
        data: barSeries || [0, 0, 0, 0, 0, 0, 0],
      },
    ],
  };

  return (
    <div className="RewardBarChart__wrapper">
      <div className="RewardBarChart__wrapper__title">Total referrals</div>
      <div className="mixed-chart">
        <Chart
          options={datas?.options}
          series={datas?.series}
          type="bar"
          // width="500"
          height={220}
        />
      </div>
    </div>
  );
};

export default RewardBarChart;
